import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./context/AuthContext";

/* LAYOUTS */
import MainLayout from "./layouts/MainLayout";
import SalesLayout from "./layouts/SalesLayout";

/* AUTH */
import Login from "./pages/auth/Login";

/* PAGES */
import Dashboard from "./pages/dashboard/Dashboard";
import InventoryList from "./pages/inventory/InventoryList";
import Units from "./pages/units/Units";
import ProductTypes from "./pages/productTypes/ProductTypes";
import Customers from "./pages/customers/Customers";
import Sales from "./pages/sales/Sales";
import PaymentIn from "./pages/paymentsIn/PaymentIn";
import Purchase from "./pages/purchase/Purchase";
import PaymentOut from "./pages/paymentsOut/PaymentOut";
import Ledger from "./pages/ledger/Ledger";
import Reports from "./pages/reports/Reports";
import DayBook from "./pages/daybook/DayBook";
import CashInHand from "./pages/cash/CashInHand";
import Company from "./pages/company/Company";
import ManageRoles from "./pages/roles/ManageRoles";
import Expense from "./pages/expenses/Expense";
import SaleReturn from "./pages/sales/SaleReturn";
import PurchaseReturn from "./pages/purchase/PurchaseReturn";
import Salesdashboard from './pages/dashboard/Salesdashbaord';

const AppRouter = () => {
  const { role, loading } = useAuth(); // Loading state zaroori hai

  if (loading) return <div>Loading...</div>;

  const getSavedRoute = () => {
    const saved = localStorage.getItem("activePage");
    // Ensure saved route isn't login if the user is already authenticated
    return (saved && saved !== "/login") ? saved : "/";
  };

  if (!role) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      {/* --- Common Protected Routes --- */}
      {role === "ADMIN" && (
        <>
          <Route path="/" element={<MainLayout><Dashboard /></MainLayout>} />
          <Route path="/cash" element={<MainLayout><CashInHand /></MainLayout>} />
          <Route path="/manageroles" element={<MainLayout><ManageRoles /></MainLayout>} />
          <Route path="/company" element={<MainLayout><Company /></MainLayout>} />
          <Route path="/daybook" element={<MainLayout><DayBook /></MainLayout>} />
          <Route path="/payment-in" element={<MainLayout><PaymentIn /></MainLayout>} />
          <Route path="/payment-out" element={<MainLayout><PaymentOut /></MainLayout>} />
          <Route path="/sales" element={<MainLayout><Sales /></MainLayout>} />
          <Route path="/purchase" element={<MainLayout><Purchase /></MainLayout>} />
          <Route path="/inventory" element={<MainLayout><InventoryList /></MainLayout>} />
          <Route path="/inventory/units" element={<MainLayout><Units /></MainLayout>} />
          <Route path="/inventory/types" element={<MainLayout><ProductTypes /></MainLayout>} />
          <Route path="/customers" element={<MainLayout><Customers /></MainLayout>} />
          <Route path="/ledger" element={<MainLayout><Ledger /></MainLayout>} />
          <Route path="/reports" element={<MainLayout><Reports /></MainLayout>} />
          <Route path="/expense" element={<MainLayout><Expense /></MainLayout>} />
          <Route path="/salereturn" element={<MainLayout><SaleReturn /></MainLayout>} />
          <Route path="/purchasereturn" element={<MainLayout><PurchaseReturn /></MainLayout>} />
        </>
      )}

      {role === "SALESMAN" && (
        <>
          <Route path="/" element={<SalesLayout><Salesdashboard /></SalesLayout>} />
          <Route path="/sales" element={<SalesLayout><Sales /></SalesLayout>} />
          
        </>
      )}

      {/* Wildcard Fallback */}
      <Route path="*" element={<Navigate to={getSavedRoute()} replace />} />
    </Routes>
  );
};



export default AppRouter;